import { c as _c } from "react/compiler-runtime";
import { MessageCircle, Phone, Video } from "lucide-react";
import type { ConsultationMode } from "../../../types/booking";
export const MODE_ICON: Record<ConsultationMode, typeof Video> = {
  VIDEO: Video,
  AUDIO: Phone,
  CHAT: MessageCircle
};
export const MODE_LABEL: Record<ConsultationMode, {
  en: string;
  hi: string;
}> = {
  VIDEO: {
    en: "Video",
    hi: "वीडियो"
  },
  AUDIO: {
    en: "Audio",
    hi: "ऑडियो"
  },
  CHAT: {
    en: "Chat",
    hi: "चैट"
  }
};
export const GROUP_LABEL: Record<"morning" | "afternoon" | "evening", {
  en: string;
  hi: string;
}> = {
  morning: {
    en: "Morning",
    hi: "सुबह"
  },
  afternoon: {
    en: "Afternoon",
    hi: "दोपहर"
  },
  evening: {
    en: "Evening",
    hi: "शाम"
  }
};
export const STEP_LABELS: {
  en: string;
  hi: string;
}[] = [{
  en: "Session type",
  hi: "सत्र प्रकार"
}, {
  en: "Mode & duration",
  hi: "मोड और अवधि"
}, {
  en: "Date & time",
  hi: "तिथि और समय"
}, {
  en: "Your concern",
  hi: "आपकी चिंता"
}, {
  en: "Review & pay",
  hi: "समीक्षा और भुगतान"
}];
export function StepperProgress(t0) {
  const $ = _c(9);
  const {
    step,
    isHindi
  } = t0;
  let t1;
  if ($[0] !== step) {
    t1 = STEP_LABELS.map((label, index) => {
      const stepNumber = index + 1;
      const isActive = stepNumber === step;
      const isDone = stepNumber < step;
      return <div key={label.en} className="flex flex-1 items-center gap-2"><div className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-semibold ${isActive ? "bg-[#155A7D] text-white" : isDone ? "bg-[#7E9A88] text-white" : "bg-slate-200 text-slate-500"}`}>{stepNumber}</div>{stepNumber < STEP_LABELS.length && <div className={`h-0.5 flex-1 rounded ${isDone ? "bg-[#7E9A88]" : "bg-slate-200"}`} />}</div>;
    });
    $[0] = step;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex items-center gap-2">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = isHindi ? STEP_LABELS[step - 1].hi : STEP_LABELS[step - 1].en;
  let t4;
  if ($[4] !== t3) {
    t4 = <p className="mt-2 text-xs font-semibold tracking-wide text-slate-500 uppercase">{t3}</p>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <div className="mb-8">{t2}{t4}</div>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}